import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {DialogContentText, TextField} from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import css from './SavePreset.module.css';
import {savePreset} from "../../../../store/filterSlice";
import LinkDiscord from "../../../Helper/Discord/LinkDiscord";

const SavePreset = (props) => {
	const [name, setName] = useState('');

	const handleSave = () => {
		if( name.trim().length > 0 ) {
			props.savePreset(name);
			props.onClose(true);
		}
	};

	if( !props.discordUser ) {
		return <LinkDiscord title='Save Preset' onClose={props.onClose}/>;
	}

	return (<Dialog className={css.Settings} open={true}>
			<DialogTitle id="alert-dialog-title">Save Preset</DialogTitle>
			<DialogContent>
				<DialogContentText>You can save your current filter settings to get a bookmarkable URL, and to add this
					view to the drop-down at the top-right corner of your screen.</DialogContentText>

					<TextField label='Preset Name' value={name} onChange={(e) => setName(e.target.value)} />
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose} color="primary" autoFocus>
					Cancel
				</Button>
				<Button onClick={handleSave} color="primary" autoFocus>
					Save Preset
				</Button>
			</DialogActions>

		</Dialog>);
};

SavePreset.propTypes = {
	onClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
	return {
		discordUser: state.core.discordUser
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		savePreset: (name) => dispatch(savePreset(name))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SavePreset);